import { render, staticRenderFns } from "./addorupdateGroupphone.vue?vue&type=template&id=17f2aa64"
import script from "./addorupdateGroupphone.vue?vue&type=script&lang=js"
export * from "./addorupdateGroupphone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports